


























































import { Vue, Component } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { translateRole } from "../utils";
import { Member } from "../types";

const Team = namespace("team");
@Component({
  components: {},
  filters: {
    translateRole,
  },
})
export default class CancelTeamInvite extends Vue {
  @Team.Action("fetchCurrentPendingMember") fetchCurrentPendingMember!: (
    memberId?: string
  ) => Promise<{}>;
  @Team.Getter("getCurrentPendingMember") currentPendingMember: Member;
  @Team.Action("fetchPendingMembers") fetchPendingMembers!: () => Promise<{}>;
  @Team.Action("cancelPendingInvitation")
  cancelPendingInvitation!: (memberId) => Promise<{}>;

  loading = false;
  hasErrors = false;
  async beforeMount() {
    const { memberId } = this.$route.params;
    await this.fetchPendingMembers();
    this.fetchCurrentPendingMember(memberId);
  }
  goBack() {
    this.$router.push({ name: "team" });
  }
  confirmInviteCancel() {
    this.loading = true;

    const { memberId } = this.$route.params;
    this.cancelPendingInvitation(memberId)
      .then(() => {
        this.loading = false;
        this.$notify({
          group: "success",
          title: "Success",
          text: "Team member invite was cancelled successfully.",
        });
        this.fetchPendingMembers();
        this.goBack();
      })
      .catch(() => {
        this.loading = false;
        this.$notify({
          group: "error",
          title: "Error",
          text: "Failed to cancel invite.",
        });
      });
  }
}
